import { createContext, useContext, useMemo } from 'react';

/** @sort alpha */
const DEFAULT_FLAGS = {
    /** Enable auto-interactive behavior for CardPrimitive */
    cardAutoInteractive: returnsFalse,
    /** Keep scroll container content below its scrollbars with an isolated stacking context. */
    scrollContainerIsolation: returnsFalse,
    /** Allow moving and resizing Windows using the keyboard. */
    windowKeyboardControls: returnsFalse,
};
const _FlagsContext = createContext(DEFAULT_FLAGS);
/**
 * Provide flags down to all FPL components, enabling or disabling certain features.
 */
const FlagsContext = _FlagsContext.Provider;
/** Get a specific flag passed in via FplSettings.FlagsContext. */
function useFlag(flag) {
    return useFlags()[flag]();
}
/** Get the flags passed in via FplSettings.FlagsContext. */
function useFlags() {
    const flags = useContext(_FlagsContext);
    return useMemo(() => ({ ...DEFAULT_FLAGS, ...flags }), [flags]);
}
function returnsFalse() {
    return false;
}

export { FlagsContext, useFlag, useFlags };
//# sourceMappingURL=settings.flags.js.map
